import React from 'react'
import { Modal, FormControl, Button, ButtonToolbar, FormGroup, ControlLabel } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from '../../../component/element/DatePicker'
import { momentHelper } from '../../../utils/helpers'


export default class EditTaskModal extends React.Component {
  constructor(props) {
    super(props)
    this.companyViewCaptions = {
      company: 'ลูกค้า',
      car_registration_no: 'ทะเบียนรถ',
      responsible_name: 'ผู้รับผิดชอบ'
    }
    this.workerViewCaptions = {
      responsible_name: 'ผู้รับผิดชอบ',
      car_registration_no: 'ทะเบียนรถ(ลูกค้า)'
    }

  }

  saveNewTask(meta) {
    return {
      work_no: meta.workNo,
      contractor_id: meta.contractor_id,
      employee_id: meta.employee_id,
      leader_id: '',
      total_cost: '',
      bf_work_damage_id: 0
    }
  }

  getTaskObjects(view) {
    const companyObject =
      this.props.workdocFixingPlanList.filter(
        (obj) => obj.company === view.company)[0]

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== view.car_registration_no) return null
      const selectedTasks =
        obj.tasklist.filter((task) =>
          task.responsible_name === view.responsible_name
        )
      return selectedTasks
    })[0]
  }

  getTaskOptions() {
    const taskOptions = [{ label: 'รื้อ', value: 'dismanlingState' },
    { label: 'เคาะ', value: 'hitState' },
    { label: 'โป๊ว', value: 'trapState' },
    { label: 'พื้น', value: 'groundState' },
    { label: 'ผสมสี', value: 'mixColorState' },
    { label: 'พ่น', value: 'paintState' },
    { label: 'ประกอบ', value: 'assemblyState' },
    { label: 'ขัดสี', value: 'polishState' },
    { label: 'ล้าง', value: 'cleanState' },
    { label: 'QC', value: 'qcState' }]

    const taskObjects = this.props.maxLevel === 3
      ? this.getTaskObjects(this.props.data.companyView)
      : this.getTaskObjects(this.props.data.workerView)
    if (taskObjects.length === 0) return []

    const assignedTasks =
      taskObjects.map((ele) => {
        const tList = ele.tasklist
        return tList[0]['taskValue']
      })
    return taskOptions.filter((ele) => assignedTasks.indexOf(ele.value) === -1)
  }

  onSaveClick = () => {
    if (typeof this.props.onEditTask === 'undefined'
    )
      return

    this.props.onEditTask()
    // if (this.props.maxLevel === 3) {
    //   // const meta = this.getMetaForTaskSave(this.props.data.companyView)
    // }
  }

  onDeleteClick = () => {
    if (typeof this.props.onDeleteTask === 'undefined'
    )
      return

    this.props.onDeleteTask()


    // var taskId = gantt.addTask({
    //   id: 10,
    //   text: "Task #5",
    //   start_date: "02-09-2013",
    //   duration: 28
    // }, "project_2", 1);
  }

  onNewTaskChange(selectedOption) {
    console.log('selectedOption', selectedOption)
    // this.setState({ taskValue: selectedOption.value })
    this.props.onNewTaskChange(selectedOption.label, selectedOption.value)
  }

  onSelectChange(key, selectedOption) {
    this.props.onSelectChange(key, selectedOption.id, selectedOption.value, this.props.maxLevel)
  }

  onStartDateChange = (dateString, dateMoment) => {
    this.props.onStartDateChange(dateString, dateMoment)
  }

  onEndDateChange = (dateString, dateMoment) => {
    this.props.onEndDateChange(dateString, dateMoment)
  }

  calculateDuration(itemData) {

    // let finishTime = moment(itemData.finishTime.date, 'DD/MM/YYYY')
    // let duration = moment.duration(finishTime.diff(moment(itemData.startTime.date, 'DD/MM/YYYY')));

    // itemData.duration = duration.asDays() + 1;
    // return itemData
  }

  getOptions(key) {
    const children = this.props.allTasks.filter(
      (task) => task.parent === this.props.data.latestSelectedId)
    return children.map((child) => ({
      value: child.name,
      label: child.name,
      id: child.id
    }))
  }

  renderFormGroups() {
    if (typeof this.props.maxLevel === 'undefined') return null
    const companyViewCaptions = {
      company: 'ลูกค้า',
      car_registration_no: 'ทะเบียนรถ',
      responsible_name: 'ผู้รับผิดชอบ',
      taskName: 'งาน'
    }
    const workerViewCaptions = {
      responsible_name: 'ผู้รับผิดชอบ',
      car_registration_no: 'ทะเบียนรถ(ลูกค้า)',
      taskName: 'งาน'
    }
    const captions = this.props.maxLevel === 3
      ? companyViewCaptions
      : workerViewCaptions
    const view = this.props.maxLevel === 3
      ? this.props.data.companyView
      : this.props.data.workerView

    return Object.keys(captions).map((key) => (
      <FormGroup
        // controlId="formBasicText"
        // validationState={this.getValidationState()}
        key={key}
      >
        <ControlLabel>{captions[key]}</ControlLabel>
        <FormControl
          type="text"
          value={view[key]}
          disabled
        />
      </FormGroup>
    ))
  }

  isReadyForNewTaskInput() {
    if (this.props.maxLevel === 3) {
      return Object.keys(this.companyViewCaptions).every(
        (key) => this.props.data.companyView[key] !== '')
    }

    return Object.keys(this.workerViewCaptions).every(
      (key) => this.props.data.workerView[key] !== '')
  }

  onStartDateChange = (dateString, dateMoment) => {
    this.props.onStartDateChange(dateString, dateMoment)
  }

  onEndDateChange = (dateString, dateMoment) => {
    this.props.onEndDateChange(dateString, dateMoment)
  }

  renderDateForms() {
    const view = this.props.maxLevel === 3
      ? this.props.data.companyView
      : this.props.data.workerView

    return (
      <FormGroup>
        <ControlLabel>เวลาเริ่ม</ControlLabel>
        <DatePicker
          // style={{ display: 'inline-block', minWidth: '160px' }}
          showIcon={true}
          showFooter={true}
          buddhistEra
          value={momentHelper.convertWorldToThaiYear(view.start_date)}
          onChange={this.onStartDateChange}
        />
        <ControlLabel>เวลาเสร็จ</ControlLabel>
        <DatePicker
          // style={{ display: 'inline-block', minWidth: '160px' }}
          showIcon={true}
          showFooter={true}
          buddhistEra
          popPlacement='top'
          value={momentHelper.convertWorldToThaiYear(view.end_date)}
          onChange={this.onEndDateChange}
        />
      </FormGroup >
    )
  }

  renderForm() {
    const formGroups = this.renderFormGroups()
    const dateForm = this.renderDateForms()
    return (
      <form>
        {formGroups}
        {dateForm}
      </form>
    )
  }

  render() {
    if (!this.props.show || typeof this.props.data === 'undefined') return null
    return (
      <Modal
        show={this.props.show}
        enforceFocus={false}
        onHide={this.props.onHide}
        bsSize="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {this.renderHeader()} */}
          {this.renderForm()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle={'danger'} onClick={this.onDeleteClick}>ลบงาน</Button>
            <Button bsStyle={'primary'} onClick={this.onSaveClick}>บันทึกงาน</Button>
            <Button onClick={this.props.onHide}>ยกเลิก</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/plan/EditTaskModal.js